import React, {useState} from 'react';
import Avatar from 'react-avatar';
import colors from '../../../lib/Colors';
import styled from 'styled-components';
import * as PropTypes from 'prop-types';
import fonts from '../../../lib/Fonts';
import I18n from 'i18n-js';
import DelimiterLine from '../DelimiterLine';
import {deleteCookie, getUrlForPublicSite} from "../../../lib/Utils";

const Wrapper = styled.div`
  display: inline-block !important;
  position: relative !important;
`

const AvatarWrapper = styled.div`
  height: 34px !important;
  cursor: pointer !important;
`

const Dropdown = styled.div`
&#wrapper-dropdown&& {
  display: ${({show}) => show ? 'block' : 'none'}; 
  padding: 0 25px 0 17px !important;
  position: absolute !important;
  width: 150px !important;
  right: 10px !important;
  overflow: auto !important;
  background-color: ${colors.white};
  box-shadow: 0 2px 4px 0 rgba(116, 116, 116, 0.5) !important;
  z-index: 999 !important;
  }
`

const DropdownList = styled.ul`
&#wrapper-dropdown-list&& {
  padding: 0 5px 0 5px !important;
  list-style-type: none;
  font-family: ${fonts.family.workSans} !important;
  }
`

const DropdownElement = styled.li`
&#wrapper-dropdown-element-1&&, &#wrapper-dropdown-element-2&&, &#wrapper-dropdown-element-3&&{
    text-align: left !important;
    cursor: pointer;
    padding: 0.2em !important;
    margin-bottom: 20px !important;
  }
  &:hover#wrapper-dropdown-element-1&&, &:hover#wrapper-dropdown-element-2&&, &:hover#wrapper-dropdown-element-3&& {
      a, button {
      color: ${colors.white} !important;
      }
      background-color: ${colors.darkerGray} !important;
    }
`

const DropdownLink = styled.a`
&#wrapper-link-my-account&&, &#wrapper-link-user-settings&& {
  text-decoration: none;
  color: ${colors.darkerGray}; /* TODO: Remove !important once we pull out monolith CSS from hubspot */
  white-space: nowrap;
  font-size: 16px !important;
  font-style: normal !important;
  border: 0 !important; /* TODO: Remove !important once we pull out monolith CSS from hubspot */
  }
`

const DropdownButton = styled.button`
  &#wrapper-dropdown-button&& {
    font-size: 16px !important;
    padding-left: 0;
    text-decoration: none;
    font-weight: bold !important;
    color: ${colors.darkerGray};
    white-space: nowrap;
    border: 0;
    background: 0;
    cursor: pointer;
  }
`

const UserAvatar = ({firstName, lastName}) => {
  const [dropdownState, setDropdownState] = useState(false);
  const avatarConfig = {
    name: `${firstName} ${lastName}`,
    size: '34',
    round: true,
    color: colors.darkerGray,
  };

  return (
    <Wrapper>
      <AvatarWrapper>
        {!dropdownState && <Avatar {...avatarConfig} onClick={() => setDropdownState(true)}/>}
        {dropdownState && <Avatar {...avatarConfig} name="X" onClick={() => setDropdownState(false)}/>}
      </AvatarWrapper>
      <Dropdown id={'wrapper-dropdown'} show={dropdownState}>
        <DropdownList id={'wrapper-dropdown-list'}>
          <DropdownElement id={'wrapper-dropdown-element-1'}>
            <DropdownLink href={ getUrlForPublicSite('/') } id={'wrapper-link-my-account'}>
              {I18n.t('hubspotWidget.myAccount')}
            </DropdownLink>
          </DropdownElement>
          <DropdownElement id={'wrapper-dropdown-element-2'}>
            <DropdownLink href={ getUrlForPublicSite('/user/edit') } id={'wrapper-link-user-settings'}>
              {I18n.t('hubspotWidget.userSettings')}
            </DropdownLink>
          </DropdownElement>
          <DelimiterLine color={colors.lighterGray}/>
          <DropdownElement id={'wrapper-dropdown-element-3'}>
            <DropdownButton id={'wrapper-dropdown-button'} onClick={() => {
              deleteCookie('userSessionIdentifier')
              window.location.reload(false)
            }}>
              {I18n.t('hubspotWidget.logout')}
            </DropdownButton>
          </DropdownElement>
        </DropdownList>
      </Dropdown>
    </Wrapper>
  )
};

UserAvatar.propTypes = {
  firstName: PropTypes.string,
  lastName: PropTypes.string,
};
export default UserAvatar;
